import * as React from 'react';

import * as styles from './styles.css';

export const AlertInfoIcon: React.FC = () => {
  return <div className={styles['info-icon']} />;
};
